export default __webpack_public_path__ + "static/media/ms3.f88c14a8.jpeg";